import {ServiceItemVM} from "./ServiceItemVM";
import {AmenityVM} from "./AmenityVM.model";
import {IntakeFormVM} from "./IntakeForm.model";
/**
 * Created by saeed on 1/3/2017.
 */
export class ServiceItemDetailVM extends ServiceItemVM {

  mustGetParticipantInfo:boolean;
  fullDescription:string;
  rating:number;
  prePaymentAmount;
  imageAlbum:any;
  amenities:ServiceItemAmenitiesVM
  scheduleInfo:ScheduleInfoDTO;
  capacityInfo:any;
  servicePriceInfo:any[];
  options:any[];
  confirmationType;
  agreement:any;
  coverImage:any;
  serviceStatus:string;
  priceInfoDtails;
  multiReserveMode;
  multiReserveConfig:MultiReserveModeConfigModel;
  intakeForm:IntakeFormVM;
  imageUrl;
  consecutiveReserveMode;
  servants:ServantVM[];
  servantSelectMode;
  meetingType: any;
  serviceMode : string;
  minConsecutivePeriod:number;
  maxConsecutivePeriod:number;

}
export class MultiReserveModeConfigModel
{
  public repeatMode:string;
  public repeatCount:number;

}
export class ScheduleInfoDTO {
  floatingTimeType:string;
  weeklyScheduleInfo:weeklyScheduleInfoVM = new weeklyScheduleInfoVM();
  scheduleType;

}
export class weeklyScheduleInfoVM {
  weekdays:WorkDayVM[];
  timePeriod:TimePeriodVM;

}

export class ServiceItemAmenitiesVM {
  amenitiesList:AmenityVM[];
}
export class WorkDayVM {
  public weekday:any;
  public timePeriod:TimePeriodVM;
}
export class TimePeriodVM {
  public startTime:Date;
  public endTime:Date;

}
export class ServantVM
{
  public id:number;
  public servantName:string;
  public description;
  public priceInfoDtails : any[];
  public code : string;

}
export enum WEEKDAYS
{
  SATURDAY, SUNDAY, MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY
}
// export enum MeetingType {
//   RW_VIDEO_CALL,FACE_TO_FACE , SKYPE_VIDEO_CALL
// }



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/ServiceItemDetailVM.ts